<script>
  import { 
    residents,
    filteredResidents,
    minResidentsSelected } from '../store.js';
  import Pagination from './Pagination.svelte';
  
  let allSelected = false;

  let displayResidents = [];

  let alertCandidateResidents = [];

  let selectedResidents = [];

  $: {
    alertCandidateResidents = [...$filteredResidents];
    allSelected = alertCandidateResidents.every(resident => resident.selected);
    selectedResidents = $residents.filter(resident => resident.selected);

  }

  const updateSelected = (residentID, selected) => { 
    const resident = alertCandidateResidents.find(resident => resident.resident_id === residentID);
    resident.selected = !selected;
    const residentsCopy = [...$residents];
    const residentIndex = [residentsCopy].indexOf(res => res.resident_id === residentID);
    residentsCopy[residentIndex] = {...residentsCopy[residentIndex], selected: !selected}
    residents.set(residentsCopy);
    // check to see if allSelected is correct
    allSelected = $residents.every(resident => resident.selected);
  }

  const paginate = (event) => {
    displayResidents = event.detail.items;
  }

  const toggleAllSelected = () => {
    allSelected = !allSelected;
    const residentsCopy = [...$residents];
    alertCandidateResidents.forEach(candidateResident => {
      const residentIndex = residentsCopy.findIndex(res => res.resident_id === candidateResident.resident_id);
      if(residentIndex >= 0) {
        residentsCopy[residentIndex] = {...residentsCopy[residentIndex], selected: allSelected};
      }
    });
    residents.set(residentsCopy);
  }
  
</script>
<div class="row">
  <div class="col-md-12 stretch-card">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          Select Recipients
          {#if !$minResidentsSelected}
            <span class='text-danger required-field no-text-transform'>(Select at least one resident)</span>
          {/if}
        </h4>
        <div class="table-responsive">
          <table id="residents" class="table table-bordered table-sm">
            <thead>
              <tr>
                <th scope='col' class='text-center'> 
                  <div class='custom-control custom-checkbox'>
                    <input 
                      class="custom-control-input" 
                      type="checkbox" 
                      id="check-all"
                      bind:checked={allSelected}
                      on:click={() => toggleAllSelected()}
                      >
                    <label class="custom-control-label" for="check-all"></label>
                  </div>
                </th>
                <th scope='col'>Account</th>
                <th scope='col'>Name</th>
                <th scope='col'>Address</th>
                <th scope='col'>City</th>
                <th scope='col'>Property Type</th>
              </tr>
            </thead>
            <tbody>
              {#if displayResidents.length === 0}
                <tr>
                  <td colspan='6' class='text-center p-5'>
                    <strong>No Residents Have Been Loaded</strong>
                  </td>
                </tr>
              {:else}
                {#each displayResidents as resident}
                  <tr>
                    <th scope='row' class='text-center'>
                      <div class='custom-control custom-checkbox'>
                        <input 
                          class="custom-control-input" 
                          type="checkbox" 
                          bind:checked={resident.selected}
                          on:click={() => updateSelected(resident.resident_id, resident.selected)}
                          id="resident-{resident.resident_id}">
                        <label class="custom-control-label" for="resident-{resident.resident_id}"></label>
                      </div>
                    </th>
                    <td>{resident.ubmax_acc}</td>
                    <td>{resident.first_name} {resident.last_name}</td>
                    <td>{resident.house_number} {resident.street}</td>
                    <td>{resident.city}</td>
                    <td>{resident.property_type}</td>
                  </tr>
                {/each}
              {/if}
            </tbody>
            <tfoot>
              <tr>
                <td colspan='6'>
                  <nav class='mt-2' aria-label="Page navigation example">
                    <Pagination items={alertCandidateResidents} on:paginate={paginate}></Pagination>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <h4 class='card-title mt-3'>Selected</h4>
        <div class='mt-2'>
          <div class="card overflow-auto" style='height: 200px;'>
            <div class="card-body">
              {#each selectedResidents as selectedResident}
                <div class='d-flex'>
                  <div class='mr-2'>
                    {selectedResident.first_name} {selectedResident.last_name} 
                  </div>
                  <div>
                    {#if selectedResident.email_1 || selectedResident.email_2}
                      <i class="mdi mdi-email icon-sm text-success" title='email available'></i>
                    {:else}
                      <i class="mdi mdi-email icon-sm text-danger" title='email not available'></i>
                    {/if}
                    {#if selectedResident.cell_1 || selectedResident.cell_2}
                      <i class="mdi mdi-message-processing icon-sm text-success" title='text available'></i>
                    {:else}
                      <i class="mdi mdi-message-processing icon-sm text-danger" title='text not available'></i>
                    {/if}
                    {#if selectedResident.home_phone}
                      <i class="mdi mdi-phone icon-sm text-success" title='phone available'></i>
                    {:else}
                      <i class="mdi mdi-phone icon-sm text-danger" title='phone not available'></i>
                    {/if}
                    <br>
                  </div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </div>
 
    </div>
  </div>
</div>
<style>
  .required-field::after {
    content: "*";
    color: red;
  }

  .no-text-transform {
    text-transform: none;
  }
</style>